import { render } from "./LessonBlocksEditor.vue?vue&type=template&id=1c60dbdc&scoped=true"
import script from "./LessonBlocksEditor.vue?vue&type=script&lang=js"
export * from "./LessonBlocksEditor.vue?vue&type=script&lang=js"

import "./LessonBlocksEditor.vue?vue&type=style&index=0&id=1c60dbdc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c60dbdc"]])

export default __exports__